import MockApi from './MockApi';
import ServerApi from './ServerApi';

const API = process.env.NODE_ENV === 'production' ? ServerApi : MockApi;

export default API;
